import { baseApi } from './baseApi';

export const claudeApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getClaudeStatus: builder.query({
      query: () => ({ url: '/api/claude/status' }),
      transformResponse: (response) => ({
        connected: !!response.connected,
        connectedAt: response.connectedAt || null,
      }),
      providesTags: ['ClaudeConnection'],
    }),

    connectClaude: builder.mutation({
      query: (apiKey) => ({
        url: '/api/claude/connect',
        method: 'POST',
        body: { apiKey },
      }),
      invalidatesTags: ['ClaudeConnection'],
    }),

    disconnectClaude: builder.mutation({
      query: () => ({
        url: '/api/claude/disconnect',
        method: 'DELETE',
      }),
      invalidatesTags: ['ClaudeConnection'],
    }),

    sendClaudeChat: builder.mutation({
      query: ({ message, history }) => ({
        url: '/api/claude/chat',
        method: 'POST',
        body: { message, history },
      }),
    }),
  }),

  overrideExisting: false,
});

export const {
  useGetClaudeStatusQuery,
  useConnectClaudeMutation,
  useDisconnectClaudeMutation,
  useSendClaudeChatMutation,
} = claudeApi;
